import type { PreFillableFormTemplateTypeEnum } from '@dealstack/prisma-client';

export const PRE_FILLABLE_FORM_TEMPLATE_TYPE_NORMALIZED_NAME: Record<
	PreFillableFormTemplateTypeEnum,
	string
> = Object.freeze({
	INDIVIDUAL: 'Individual',
	VEHICLE: 'Personal investment vehicle',
});

export const PRE_FILLABLE_FORM_TEMPLATE_TYPE_OPTIONS: {
	value: PreFillableFormTemplateTypeEnum;
	label: string;
}[] = [
	{
		value: 'INDIVIDUAL',
		label: PRE_FILLABLE_FORM_TEMPLATE_TYPE_NORMALIZED_NAME.INDIVIDUAL,
	},
	{
		value: 'VEHICLE',
		label: PRE_FILLABLE_FORM_TEMPLATE_TYPE_NORMALIZED_NAME.VEHICLE,
	},
];
